import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Table } from './Table';
import { StringSelectFilter } from './StringSelectFilter';
import { fetchMediaIfOK, updateMediaIfOK,
         selectMedia,    deselectMedia,
         selectAllMedia, deselectAllMedia, showViewSourceModal, setPreviewMediaSource, setMediaRowObject } from '../../actions';

const stringSelectFilter = (filterHandler, customFilterParams) => {
    // Gets a custom string select filter. This is used in the language column
    return (
        <StringSelectFilter filterHandler={filterHandler} items={customFilterParams.items} />
    );
};

const mediaCellValidation = (row, cellName, cellValue) => {
    // Do not submit nan datasets thats stupid
    if (cellName === 'DatasetNum') {
        return isNaN(parseInt(cellValue, 10));
    }
};

class TableContainer extends Component {
    constructor (props) {
        super(props);

        this.selectMedia = this.selectMedia.bind(this);
        this.selectAllMedia = this.selectAllMedia.bind(this);
        this.mediaRowUpdate = this.mediaRowUpdate.bind(this);
    }    

    selectMedia (row, isSelected) {
        // sets the state for selected rows.
        const { scene, selectMedia, deselectMedia } = this.props;

        if (isSelected) {
            selectMedia(scene, row);
        } else {
            deselectMedia(scene, row);
        }
    }

    selectAllMedia (isSelected, rows) {
            // handles bulk selection
            const { scene, selectAllMedia, deselectAllMedia } = this.props;

            if (isSelected) {
                selectAllMedia(scene, rows);
            } else {
                deselectAllMedia(scene, rows);
            }
    }

    mediaRowUpdate (row, column, value) {
        const { updateMediaIfOK, scene } = this.props;

        let updatePayload = {
            mediaName: row.mediaName,
            datasetNum: parseInt(row.datasetNum, 10),
            language: row.language,
        };

        if (column === 'sourcePath') {
            // If the path changed then the usual media id this points to has changed.
            // This version of the call will look up the first source media matching these parameters, and if it cant find it, creates it.
            // Only do it in this case because this has the potential to be a very heavy operation.
            updatePayload = Object.assign(updatePayload, {
                mediaPath: row.sourcePath,
                mediaRepository: row.sourceRepository
            });
        } else {
            // This is a fast update favor this plz
            updatePayload = Object.assign(updatePayload, {
                mediaId: row.mediaID
            });
        }

        updateMediaIfOK(scene, row.sceneMediaID, updatePayload);
    }

    componentWillMount() {
        const { scene, fetchMediaIfOK, setPreviewMediaSource } = this.props;
        fetchMediaIfOK(scene);
        if (!setPreviewMediaSource) {
            setPreviewMediaSource("test/test");
        }
    }

    componentWillReceiveProps(nextProps) {
        const { scene, fetchMediaIfOK, mediaItems: newMedia } = nextProps;
        const { mediaItems: oldMedia, deselectAllMedia} = this.props;

        fetchMediaIfOK(scene);

        // if any are selected in old media AND none are selected in new media, then we refreshed the media
        // reset the selected urls
        if (_.some(oldMedia, m => m.selected) && !_.some(newMedia, m => m.selected)) {
            deselectAllMedia(scene, _.filter(oldMedia, m => m.selected));
        }
    }

    render() {
        const { mediaItems, scene, showViewSourceModal, setPreviewMediaSource, setMediaRowObject, mediaPreview, mediaRowObject } = this.props;
        return (
            <Table
                mediaItems={mediaItems} 
                onBeforeSaveCell={mediaCellValidation} 
                onAfterSaveCell={this.mediaRowUpdate} 
                handleRowSelect={this.selectMedia} 
                handleAllSelect={this.selectAllMedia} 
                languageFilter={stringSelectFilter} 
                scene={scene} 
                showViewSourceModal={showViewSourceModal} 
                setPreviewMediaSource={setPreviewMediaSource} 
                setMediaRowObject={setMediaRowObject} 
                mediaPreview={mediaPreview}
                mediaRowObject={mediaRowObject}
            />
        );
    }
}

TableContainer.propTypes = {
    scene:            PropTypes.string.isRequired,
    fetchMediaIfOK:   PropTypes.func.isRequired,
    selectMedia:      PropTypes.func.isRequired,
    deselectMedia:    PropTypes.func.isRequired,
    selectAllMedia:   PropTypes.func.isRequired,
    deselectAllMedia: PropTypes.func.isRequired,
    updateMediaIfOK:  PropTypes.func.isRequired,
    mediaItems:       PropTypes.array,
    showViewSourceModal: PropTypes.func.isRequired,
    mediaPreview: PropTypes.string,
    setPreviewMediaSource: PropTypes.func.isRequired,
    setMediaRowObject: PropTypes.func.isRequired,
    mediaRowObject: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    const scene = state.scene.current;
    const sceneMedia = state.mediaByScene[scene];
    const mediaItems = sceneMedia ? sceneMedia.mediaItems : [];
    const mediaPreview = state.ui.previewMedia.mediaPreview;
    const mediaRowObject = state.ui.previewMedia.mediaRowObject;

    return {
        scene,
        mediaItems,
        mediaPreview,
        mediaRowObject
    };
};

const mapDispatchToProps = {
    fetchMediaIfOK,
    selectMedia,
    deselectMedia,
    selectAllMedia,
    deselectAllMedia,
    updateMediaIfOK,
    showViewSourceModal,
    setPreviewMediaSource,
    setMediaRowObject
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableContainer);



// WEBPACK FOOTER //
// ./src/components/table/TableContainer.js